import { gql } from '@apollo/client';

export const GET_SINGLE_GAME_INFO = gql`
  query ($id: Int!, $teams: [Int!]) {
    schedule(where: { id: { _eq: $id } }) {
      id
      awayGoalie
      awayScore
      awayShots
      awayTeam {
        abbreviation
        name
        id
      }
      cancel
      division
      date
      homeGoalie
      homeScore
      homeShots
      homeTeam {
        abbreviation
        id
        name
      }
      location
      ot
      playoffs
      seasonId
      time
      rinkLocation {
        city
        name
        id
      }
      attendance {
        teamId
        player {
          id
          firstName
          lastName
          position
          positionSecondary
          jersey
          jerseySecondary
          rosters {
            team {
              id
              name
            }
          }
        }
      }
      goals(order_by: { time: asc, id: asc }) {
        id
        period
        gw
        pp
        sh
        en
        teamId
        time
        goalPlayer {
          firstName
          lastName
          id
        }
        primaryAssistPlayer {
          firstName
          lastName
          id
        }
        secondaryAssistPlayer {
          firstName
          lastName
          id
        }
      }
      penalties {
        id
        minutes
        penalty
        period
        player {
          id
          firstName
          lastName
        }
        teamId
        time
      }
    }
  }
`;
